// extracted by mini-css-extract-plugin
export default {"container":"Skeleton_container__JXX40","header":"Skeleton_header__nzGuD","content":"Skeleton_content__LJZaN","footer":"Skeleton_footer__Y9TcN"};